import type { Events } from "enums/EventEnum";
import { useCallback } from "react";
import { Analytics } from "services/Analytics/Analytics";

const useWindowOpenWithAnalytics = (url: string, eventName: Events) =>
    useCallback(() => {
        Analytics.Instance.sendEvent(eventName);
        window.open(url, "_blank", "noopener noreferrer");
    }, [url, eventName]);

export default useWindowOpenWithAnalytics;
